/*
 * Copyright (c), Onnorokom Web Services Ltd (OWSL) and/or its affiliates. All rights reserved.
 * OWSL PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
*/

import { getProductHtml } from './modules/electronic-product-module';
import { initRecentlyViewScript } from '../../common/js/recently-view-storage';

const PAGE_CONTEXT = $("meta[name='context-path']").attr('content'),
    LOGIN_PAGE = PAGE_CONTEXT + "/login",
    CSRF = $("meta[name='csrf-token']").attr('content'),
    PRODUCT_ID = $('#js--product-id').val(),
    REVIEW_PATH = '/productreviews/',
    QUESTION_PATH = '/product-questions/';

const applicationProperties = require('../../../applicationProperties.json'),
    PRODUCT_IMAGE_URL = applicationProperties.productImageUrl,
    USER_IMAGE_URL = applicationProperties.userImageUrl,
    IMAGE_FILE_PATH = applicationProperties.imgFilePath;

const messageContainer = $('#js--message');
const messageText = $('#js--message-text');
const incorrectMessageContainer = $('#js--message-incorrect-info');
const incorrectMessageText = $('#js--incorrect-info-message-text');
const questionMessageContainer = $('#js--message-question-container');
const questionMessageText = $('#js--question-message-text');

let qtyCountTemplate = '';

function initiateZoomer() {
    $('#js--product-image').elevateZoom({
        zoomWindowHeight: 430,
        zoomWindowPosition: 1,
        zoomWindowOffetx: 20,
        borderSize: 1,
        borderColour: '#ccc',
        zoomWindowFadeIn: true,
        zoomWindowFadeOut: true,
        lensFadeIn: true,
        lensFadeOut: true,
    });
}

$(document).on('mouseover', '#js--thumbnil-list li:not(.js--list-video)', function() {
    $('#js--product-image').removeClass('youtube-video');
    $('#js--product-image img').attr('src', $(this).attr('hoverImg'));
    $('#js--product-image').data('zoom-image', $(this).attr('hoverMax'));
    initiateZoomer();
});

initiateZoomer();

$(document).on('mouseover', '#js--thumbnil-list .js--list-video', function() {
    $('#js--product-image').addClass('youtube-video').attr('video-id', $(this).attr('video-id'));
    $('#js--product-image img').attr('src', $(this).attr('hoverImg'));
    $('.zoomContainer').remove();
});

$(document).on('click', '.youtube-video', function() {
    setTimeout(() => $('#js--overlay').show(), 10);
    $('#video-popup .pagesArea').html(`
        <iframe width="800" height="450" src="https://www.youtube.com/embed/${$(this).attr('video-id')}"
            frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
        </iframe>
    `);
    $('#video-popup').fadeIn(500);
});

$(document).on('click', 'div.lookInsideDiv,div.exitBtn,div.overlay', () => {
    $('#js--overlay').fadeOut(500);
    $('#video-popup').fadeOut(500);
    $('#video-popup .pagesArea').html('');
});

$('.js--back-order').click(function () {
    if (!document.querySelector('meta[name=user-id]')) {
        location.href = LOGIN_PAGE;
    } else {
        $.getJSON(PAGE_CONTEXT + '/backorder?productId=' + PRODUCT_ID, function (data) {
            messageText.html(data.data);
            $('html').animate({ scrollTop: 0 }, 'slow');
            messageContainer.slideDown();
        });
    }
});

$('.js--back-order').on('mouseover', function () {
    $(this).tooltip('show');
});

$('.js--back-order').on('mouseleave', function () {
    $(this).tooltip('hide');
});

$(window).scroll(() => {
    const ele = $('#js--similar-product');
    if (ele.hasClass('loading') && $(window).scrollTop() >= (ele.offset().top - $(window).height() - 100)) {
        ele.removeClass('loading');
        $.getJSON(PAGE_CONTEXT + '/recommendationfordetailspage/' + PRODUCT_ID, response => {
            const similarProducts = response.map((item, index) => getProductHtml(item, index, "rec_" + index + "_p_" + PRODUCT_ID)).join('');
            ele.html(similarProducts);
        }).done(() => ele.slick('refresh'));
    }
});

$(window).scroll(() => {
    const ele = $('#js--sponsored-category-products-row-1');
    if (ele.hasClass('loading') && $(window).scrollTop() >= (ele.offset().top - $(window).height() - 100)) {
        ele.removeClass('loading');
        $.getJSON(PAGE_CONTEXT + '/sponsored-individual-category-products-row-1/' + PRODUCT_ID, response => {
            const sponosredProducts = response.map((item, index) => getProductHtml(item, index, "sp_cat_" + index + "_p_" + PRODUCT_ID)).join('');
            ele.html(sponosredProducts);
        }).done(() => ele.slick('refresh'));
    }
});

$(window).scroll(() => {
    const ele = $('#js--related-products');
    if (ele.hasClass('loading') && $(window).scrollTop() >= (ele.offset().top - $(window).height() - 100)) {
        ele.removeClass('loading');
        $.getJSON(PAGE_CONTEXT + '/related-products/' + PRODUCT_ID, response => {
            const relatedProducts = response.map((item, index) => getProductHtml(item, index, "rel_" + index + "_p_" + PRODUCT_ID)).join('');
            if(!jQuery.isEmptyObject(response)){
                $('#related').removeClass('d-none');
            }
            ele.html(relatedProducts);
        }).done(() => ele.slick('refresh'));
    }
});

$(window).scroll(() => {
    const ele = $('#js--sponsor-products');
    if (ele.hasClass('loading') && $(window).scrollTop() >= (ele.offset().top - $(window).height() - 100)) {
        ele.removeClass('loading');
        $.getJSON(PAGE_CONTEXT + '/sponsored-with-individual/' + PRODUCT_ID, response => {
            const sponsorProducts = response.map((item, index) => getProductHtml(item, index, "sp_in_" + index + "_p_" + PRODUCT_ID)).join('');
            ele.html(sponsorProducts);
        }).done(() => ele.slick('refresh'));
    }
});

//  Saves product in list
$('#js--save-to-list').click(function (e) {
    e.stopPropagation();
    if (document.querySelector('meta[name=user-id]')) {
        getLists();
    } else {
        location.href = LOGIN_PAGE;
    }
});

// Get User Created List
function getLists() {
    var listData = '';
    var url = `${PAGE_CONTEXT}/loadplist`;
    $.get(url, function (plists) {
        listData = plists.map(data => {
            return `<li class="text-truncate">
                        <a class="js--wish-list" href="#" id="${data.plistId}">
                            ${data.image ? `<img src="${PRODUCT_IMAGE_URL}/130X186/${data.image}" alt="${data.image} image" />` : ''} ${data.plistName}
                        </a>
                    </li>`;
        });
        listData.push('<li class="special-list"><a href="#" class="js--save-to-wish-list">Add to My Wishlist</a></li>');
        listData.push('<li class="special-list"><a href="#" class="js--create-list"><span class="ion-android-add"></span> Create a New List</a></li>');
        $('#js--save-to-list--item').html(listData.join(''));
        if ($('#js--save-to-list--item').height() > 125) {
            $('#js--save-to-list--item').css({
                height: '125px',
                overflowY: 'scroll'
            });
        }
        $('#js--save-to-list--item').toggleClass('active');
        $('.js--create-list').on('click', () => {
            $('#js--create-list-modal').fadeIn();
            setTimeout(() => $('#js--overlay').show(), 10);
        });
    });
}

$('.js--btn-cancel').on('click', () => {
    $('#js--create-list-modal #list_title').val('');
    $('#js--create-list-modal .desc').val('');
    $('#js--create-list-modal').fadeOut();
    setTimeout(() => $('#js--overlay').hide(), 10);
});

$(document).on('click', '.js--wish-list', function () {
    const listId = $(this).attr('id');
    $.get(`/addtouserplist?plistId=${listId}&productId=${PRODUCT_ID}`, (message) => {
        messageText.html(message);
        messageContainer.slideDown();

        try {gtag('event', 'add_to_list', {content_type: 'Stationary',items:[{item_id:'rok_'+PRODUCT_ID}]});} catch (error) {}
    });
});

// Save to wishlist
$(document).on('click', '.js--save-to-wish-list', function () {
    if (!document.querySelector('meta[name=user-id]')) {
        location.href = LOGIN_PAGE;
    } else {
        $.ajax({
            type: 'POST',
            url: '/addtowishlist',
            data: `productId=${PRODUCT_ID}&variationId=0&_tk=${CSRF}`,
            success: function (response) {
                if (response.status === 'loginFirst') {
                    location.href = LOGIN_PAGE;
                } else {
                    messageText.html(response.data);
                    messageContainer.slideDown();

                    try {gtag('event', 'add_to_wishlist', {content_type: 'Stationary', items:[{item_id:'rok_'+PRODUCT_ID}]});} catch (error) {}
                    try {
                        fbq('track', 'AddToWishlist', {
                            content_ids: PRODUCT_ID,
                            content_type: 'product',
                        });
                    } catch (error) { }
                }
            }
        });
    }
});

// Create List Functionality
$('.js--btn-create-list').on('click', function (e) {
    e.preventDefault();
    const title = $('#list_title').val();
    const category = $('.custom-select option:selected').val();
    const type = $('input[name="pvc"]:checked').val();
    const description = $('.desc').val();
    if (!title) {
        $('#js--create-list-modal #list_title').css('border-color', '#dc3545');
        $('.js--err-msg').text('Title name is required');
    } else {
        $('#js--create-list-modal #list_title').css('border-color', '#ced4da');
        $('.js--err-msg').text('');
    }
    if (title && category && type) {
        const data = 'listName=' + title  + '&listDetails=' + description + '&listType=' + type + '&listCategory=' + category + '&productList=' + [PRODUCT_ID] + '&_tk=' + CSRF;
        $.ajax({
            type: 'POST',
            url: pageContext + '/my-section/list-create',
            data: data,
            success: function (response) {
                if (response.result) {
                    messageText.html(response.message);
                    messageContainer.slideDown().removeClass('alert-danger').addClass('alert-success');
                } else {
                    messageText.html(response.message);
                    messageContainer.slideDown().removeClass('alert-success').addClass('alert-danger');
                }
                $('#js--create-list-modal').fadeOut();
                setTimeout(() => $('#js--overlay').hide(), 10);
            },
            error: function (error) {},
            complete: function () {
                $('#js--create-list-modal #list_title').val('');
                $('#js--create-list-modal .desc').val('');
            }
        });
    }
});

$('#js--create-list-modal').on('click', e => e.stopPropagation());

$(document).on('click', 'html, body', (event) => {
    $('#js--save-to-list--item').removeClass('active');
    if ($(event.target).closest('#js--create-list-modal').hasClass('create-list-modal') || $(event.target).is('.js--create-list')) {
        return;
    }
    $('#js--create-list-modal #list_title').val('');
    $('#js--create-list-modal .desc').val('');
    $('#js--create-list-modal').fadeOut();
});

// Social Media Share (Facebook, Twitter, Linkedin, Instagram, WhatsApp, Messenger)
const facebookShare = $('a[data-js="facebook-share"]');
const twitterShare = $('a[data-js="twitter-share"]');
const linkedinShare = $('a[data-js="linkedin-share"]');
const instagramShare = $('a[data-js="instagram-share"]');
const whatsappShare = $('a[data-js="whatsapp-share"]');
const messengerShare = $('a[data-js="messenger-share"]');

function socialShare(e, mediaUrl, mediaDialog) {
    e.preventDefault();
    const mediaWindow = window.open(mediaUrl, mediaDialog, 'width=100');
    if (mediaWindow.focus) {
        mediaWindow.focus();
    }
}

facebookShare.on('click', (e) => {
    socialShare(e, `https://www.facebook.com/sharer/sharer.php?u=${location.href}`, 'facebook-share-dialog');
});

twitterShare.on('click', (e) => {
    socialShare(e, `https://www.twitter.com/share?u=${location.href}`, 'twitter-popup');
});

linkedinShare.on('click', (e) => {
    socialShare(e, `https://www.linkedin.com/shareArticle?mini=true&u=${location.href}`, 'linkedin-popup');
});

instagramShare.on('click', (e) => {
    socialShare(e, `https://www.instagram.com/share?u=${location.href}`, 'instagram-popup');
});

whatsappShare.on('click', (e) => {
    socialShare(e, `https://api.whatsapp.com/send?text=${location.href}`, 'whatsapp-popup');
});

messengerShare.on('click', (e) => {
    socialShare(e, `https://www.facebook.com/dialog/send?app_id=774609843808875&link=${location.href}&redirect_uri=https://rokomari.com`, 'messenger-popup');
});

let questionPageNo = 1;
let question = '';

showQuestionAnswer(PAGE_CONTEXT + QUESTION_PATH + PRODUCT_ID + '/', questionPageNo);

$('#js--show-more-question').on('click', function (e) {
    e.preventDefault();
    questionPageNo++;
    showQuestionAnswer(PAGE_CONTEXT + QUESTION_PATH + PRODUCT_ID + '/', questionPageNo);
});

function showQuestionAnswer(url, nthPage) {
    $('.js--question-answer-content').empty();
    $.ajax({
        type: 'GET',
        url: url + nthPage,
        async: false,
        success: function (response) {

            if (response.length === 0){
                $('#js--show-more-question').remove();
            }

            const questions = response.map(data => {
                if (data.isLastPage) {
                    $('#js--show-more-question').remove();
                }

                return `
                    <div class="item__wrapper">
                        <div class="item__wrapper--question d-flex">
                            <p class="font-weight-bold ml-0 mr-0">Q: </p>
                            <p class="ml-2">
                                <span>${data.question}?</span>
                                <span class="ques-by">Questioned by </span><span class="font-weight-bold">${data.askedByAccountName}</span>
                                <span class="ques-by">on ${data.askedDate}</span>
                            </p>
                        </div>
                        ${data.answer != null ? `
                            <div class="item__wrapper--submit">
                                <div class="item__wrapper--answer d-flex">
                                    <p class="font-weight-bold ml-0 mr-0">A: </p>
                                    <p class="ml-2">
                                        <span>${data.answer}</span>
                                        <span class="ans-by">Answered by </span><span class="font-weight-bold">${data.answeredByAccountName}</span>
                                        <span class="ans-by">on ${data.answeredDate}</span>
                                    </p>
                                </div>
                            </div>`: ''}
                    </div>`

            }).join('');
            $('.js--question-answer-content').html(questions);
        }
    });
}

// Submit Question Event
$('#js--question-submit').click(function () {
    question = $('#js--question-writing').val();
    if (!question.trim()) {
        questionMessageText.html('Please write your question below');
        questionMessageContainer.slideDown().removeClass('alert-success').addClass('alert-danger');
    } else {
        $.post(PAGE_CONTEXT + '/writeuserquestion', 'productId=' + PRODUCT_ID + '&question=' + question + '&_tk=' + CSRF,
            function (message) {
                questionMessageText.html(message);
                questionMessageContainer.slideDown().removeClass('alert-danger').addClass('alert-success');
                showQuestionAnswer(PAGE_CONTEXT + QUESTION_PATH + PRODUCT_ID + '/', 1);
                $('#js--question-writing').val('');
            }
        );
        $('.js--show-qa-form').removeClass('d-none');
        $('.js--qa-form').parent().slideUp();
    }
});

// Show question-answer form
$('.js--show-qa-form').on('click', function () {
    $(this).addClass('d-none');
    $('.js--qa-form').parent().removeClass('d-none').slideDown();
});

// Script for read more
$(document).on('click', '.js--read-more', function (e) {
    $(this).parent().hide();
    $(this).parent().prev().find('.read-more-overlay--container').hide();
    $(this).parent().prev().find('.user-review-container--description').css('max-height', '3000px');
});

// START - Submits incorrect information
$('#js--show-hide-reporting').click(function (e) {
    e.preventDefault();
    if (document.querySelector('meta[name=user-id]')) {
        $('#js--report-writing').slideToggle();
    } else {
        location.href = LOGIN_PAGE;
    }
});

$('#js--submit-incorrect-report').click(function () {
    var incorrectInformation = $('#js--incorrect-information').val();
    if (!document.querySelector('meta[name=user-id]')) {
        location.href = LOGIN_PAGE;
    } else if (incorrectInformation != '' && incorrectInformation != null) {
        $.post(
            PAGE_CONTEXT + '/saveproductreport',
            'id=' + PRODUCT_ID + '&comment=' + incorrectInformation + '&_tk=' + CSRF,
            function (data) {
                $('#js--report-writing').slideUp();
                if (data === 'saved') {
                    if (incorrectMessageContainer.hasClass('alert-danger')) {
                        incorrectMessageContainer.removeClass('alert-danger')
                    }
                    if (incorrectMessageContainer.hasClass('alert-warning')) {
                        incorrectMessageContainer.removeClass('alert-warning')
                    }
                    incorrectMessageContainer.addClass('alert-success');
                    incorrectMessageText.html('Thank you for supporting us.');
                    incorrectMessageContainer.slideDown();
                    incorrectMessageText.val('');
                }
                else {
                    if (incorrectMessageContainer.hasClass('alert-success')) {
                        incorrectMessageText.removeClass('alert-success')
                    }
                    if (incorrectMessageContainer.hasClass('alert-warning')) {
                        incorrectMessageText.removeClass('alert-warning')
                    }
                    incorrectMessageContainer.addClass('alert-danger');
                    incorrectMessageText.html('Sorry! Your report can not be saved.');
                    incorrectMessageContainer.slideDown();
                }
            }
        );
    } else {
        if (incorrectMessageContainer.hasClass('alert-success')) {
            incorrectMessageText.removeClass('alert-success')
        }
        if (incorrectMessageContainer.hasClass('alert-danger')) {
            incorrectMessageText.removeClass('alert-danger')
        }
        incorrectMessageContainer.addClass('alert-warning');
        incorrectMessageText.html('Please write in detail.');
        incorrectMessageContainer.slideDown();
    }
});
// END - Submits incorrect information

/**
 * Show more and show less functionality
*/

const summaryElement = $('#js--summary-description');
const specificationExpandButton = $('#js--summary-read-expand');

if (!$('#js--summary-description p').length) {
    summaryElement.find('table').removeClass('border-top mt-4 pt-3');
}

if (summaryElement.prop('scrollHeight') - summaryElement.height() > 200) {
    summaryElement.removeClass('active');
    specificationExpandButton.removeClass('d-none');
} else {
    summaryElement.addClass('active');
    specificationExpandButton.addClass('d-none');
}

specificationExpandButton.on('click', function () {
    summaryElement.toggleClass('active');
    if (summaryElement.hasClass('active')) {
        $(this).text('Show Less').css('margin-top', '20px');
    } else {
        $(document).scrollTop($('#js--summary-specification-section').prop('scrollHeight'));
        $(this).text('Show More').css('margin-top', '0');
    }
});

$('#js--minus-btn').on('click', function() {
    $('#js--details-quantity').val(Number.parseInt($('#js--details-quantity').val()) <=1 ? 1 : Number.parseInt($('#js--details-quantity').val()) - 1);
});

$('#js--plus-btn').on('click', function() {
    $('#js--details-quantity').val(Number.parseInt($('#js--details-quantity').val()) >=99 ? 99 : Number.parseInt($('#js--details-quantity').val()) + 1);
});

$(() => {
    if (variations && variations.length > 0) {
        let activeVariation;
        variations.forEach(variation => {
            if (variation.productId === activeProductId) {
                return activeVariation = variation;
            }
        });
        const variationName = $('#variation-' + activeVariation.variationValue1Id).prop('checked', true).next('label').data('name');
        const variationName2 = $('#variation-' + activeVariation.variationValue2Id).prop('checked', true).next('label').data('name');
        const variationQuantity = $('#variation-' + activeVariation.variationValue1Id).prop('checked', true).next('label').data('quantity');
        if (!variationQuantity) {
            $('#js--stock-qty').removeClass('d-flex').addClass('d-none');
        } else {
            $('#js--stock-qty').removeClass('d-none').addClass('d-flex');
            $('#js--stock-qty').next('.qty-stock-message').show();
            if (variationQuantity > 50) {
                qtyCountTemplate = `In Stock (50+ pieces available)`;
            } else if (variationQuantity > 20) {
                qtyCountTemplate = `In Stock (${qtyCountTemplate} pieces available)`;
            } else {
                qtyCountTemplate = `In Stock <span class="text-danger ml-1">(only ${variationQuantity} ${variationQuantity < 2 ? 'piece' : 'pieces'} left)</span>`;
            }
            $('#js--total-qty-available').html(qtyCountTemplate);
        }
        $('#js--variation-name').text(variationName);
        $('#js--variation-name-2').text(variationName2);
        $('#variation-' + activeVariation.variationValue1Id).prop('checked', true).next('label').addClass('active');
        $('#variation-' + activeVariation.variationValue2Id).prop('checked', true).next('label').addClass('active');
        updateAvailableVariation2(activeVariation.variationValue1Id);
    }
});

$('input[name=variation-one]').change(event => {
    const variationName = $('input[name=variation-one]:checked').next('label').data('name');
    const variationQuantity = $('input[name=variation-one]:checked').next('label').data('quantity');
    if (!variationQuantity) {
        $('#js--stock-qty').removeClass('d-flex').addClass('d-none');
        $('#js--stock-qty').next('.qty-stock-message').hide();
    } else {
        $('#js--stock-qty').removeClass('d-none').addClass('d-flex');
        $('#js--stock-qty').next('.qty-stock-message').show();
        if (variationQuantity > 50) {
            qtyCountTemplate = `In Stock (50+ pieces available)`;
        } else if (variationQuantity > 20) {
            qtyCountTemplate = `In Stock (${qtyCountTemplate} pieces available)`;
        } else {
            qtyCountTemplate = `In Stock <span class="text-danger ml-1">(only ${variationQuantity} ${variationQuantity < 2 ? 'piece' : 'pieces'} left)</span>`;
        }
        $('#js--total-qty-available').html(qtyCountTemplate);
    }
    $('#js--variation-name').text(variationName);
    updateAvailableVariation2(Number($('input[name=variation-one]:checked').val()));
});
$('input[name=variation-one], input[name=variation-two]').change(event => {
    $(event.target).closest('div.content').find('label').removeClass('active');
    $(event.target).next('label').addClass('active');
    const val1 = Number($('input[name=variation-one]:checked').val());
    const val2 = $('input[name=variation-two]:checked').val();
    const variationValue2 = $('input[name=variation-two]:checked').next('label').data('name');
    $('#js--variation-name-2').text(variationValue2);
    const selectedVariation = getVariation(val1, val2);
    if (selectedVariation) {
        updateImages(selectedVariation.images);
        updatePrice(selectedVariation.listPrice, selectedVariation.sellPrice);
        updateCartButton(selectedVariation.productId);
    }
});
function updatePrice(listPrice, sellPrice) {
    const formatter = new Intl.NumberFormat();
    $('#js--price-div').html(`
        ${listPrice > sellPrice ? `<strike class="original-price">TK. ${formatter.format(listPrice)}</strike>` : ``}
        <span class="sell-price">TK. ${formatter.format(sellPrice)}</span>
        ${listPrice > sellPrice ? `
            <span class="discount">
                <span class="js--save-message">
                    You Save TK. ${formatter.format(listPrice - sellPrice)}
                    (${Math.round((listPrice - sellPrice) / listPrice * 100)}%)
                </span>
            </span>
        ` : ``}
    `);
}
function updateImages(images) {
    $('#js--product-image img').attr('src', `${productImageUrl}/260X372/${images[0]}`);
    let thumbnails = '';
    images.forEach(image => {
        if (image.indexOf('.') === -1) {
            thumbnails += `
            <li class="js--list-video" hoverImg="https://i.ytimg.com/vi/${image}/mqdefault.jpg" video-id="${image}">
                <img src="${imgFilePath}/video.jpg" alt="youtube thumbnail"/>
            </li>`;
        } else {
            thumbnails += `
            <li class="js--list-img" hoverImg="${productImageUrl}/260X372/${image}" hoverMax="${productImageUrl}/1104X1581/${image}">
               <img src="${productImageUrl}/45X64/${image}" alt="product image"/>
            </li>`;
        }
    });
    $('#js--thumbnil-list').html(thumbnails);
    $('#js--thumbnil-list li:first-child').trigger('mouseover');
}
function updateCartButton(productId) {

    const goToCartBtn = `
            <a href="/cart?ref=dt_crt" class="add-to-cart-btn-details-page"
                    onClick="gtag('event', 'go_to_cart', {content_type: 'Stationary', items:[{item_id:'rok_'+${productId}}]});ga('send', 'event', 'Details', 'Click', 'Details-Click_on_Details_GoToCart_Button-Click');">
                <img src="${imgFilePath}/svg/cart-mini.svg" alt="cart icon"><span>Go To Cart <img src="${IMAGE_FILE_PATH}/svg/icons/rok-icon-arrow-right.svg" class="icon-arrow-right" alt="arrow right icon" /></span>
            </a>`;
    const addToCartBtn = `
            <a product-id="${productId}" class="add-to-cart-btn-details-page js--add-to-cart"
                    onClick="ga('send', 'event', 'Details', 'Click', 'Details-Click_on_Details_AddToCart_Button-Click');">
                <img src="${imgFilePath}/svg/cart-mini.svg" alt="cart mini icon"/><span>Add to Cart</span>
            </a>`;
    if (cartProductIds.indexOf(productId) === -1) {
        $('#js--details-btn-area').html(addToCartBtn);
    } else {
        $('#js--details-btn-area').html(goToCartBtn);
    }
}
$(document).on('click', '#js--details-btn-area > a.js--add-to-cart', event => {
    const productId = Number($('#js--details-btn-area > a').attr('product-id'));
    cartProductIds.push(productId);
    updateCartButton(productId);
});
function getVariation(val1,  val2) {
    let v;
    variations.forEach(variation => {
        if (variation.variationValue1Id === val1 && variation.variationValue2Id == val2) {
            return v = variation;
        }
    });
    return v;
}
function getAvailableVal2(val1) {
    const val2s = [];
    variations.forEach(variation => {
        if (variation.variationValue1Id === val1) {
            val2s.push(variation.variationValue2Id);
        }
    });
    return val2s;
}
function updateAvailableVariation2(val1) {
    const availableVal2s = getAvailableVal2(val1);
    $('input[name=variation-two]').each((index, input) => {
        if (availableVal2s.indexOf(Number($(input).val())) === -1) {
            $(input).attr('disabled', true).prop('checked', false)
                    .next('label').removeClass('active').addClass('disabled');
        } else {
            $(input).attr('disabled', false).next('label').removeClass('disabled');
        }
    });
    if (!$('input[name=variation-two]:checked').val()) {
        $('input[name=variation-two]:not(:disabled):first').trigger('click');
    }
}


initRecentlyViewScript();

/**
 * Sponsord product carousel control
 */
$('#js--sponsored-carousel').on('slide.bs.carousel', function (e) {
    if (e.direction === 'left') {
        $('#js--sponsored-carousel .btn-prev').addClass('active');
    }
    if (e.direction === 'right') {
        $('#js--sponsored-carousel .btn-next').addClass('active');
    }
    if ($(e.relatedTarget)[0] == $('#js--sponsored-carousel .carousel-item:last-child')[0]) {
        $('#js--sponsored-carousel .btn-next').removeClass('active');
    }
    if ($(e.relatedTarget)[0] == $('#js--sponsored-carousel .carousel-item:first-child')[0]) {
        $('#js--sponsored-carousel .btn-prev').removeClass('active');
    }
});

/**
 * The function generates a template for a category tag with a link and name.
 * @param {string} id
 * @param {string} name
 * @returns {string}
 */
function generateCategoryTagTemplate({id, name}) {
    return `<a href="/book/category/${id}?ref=dp_ct${id}" class="btn category-tag__item">
                ${name}
            </a>`;
}

/**
 * This function sends an AJAX request to retrieve category tags for a product and generates HTML
 * templates to display them.
 */
function getCategories() {
    $.ajax({
        url: '/category-tag/' + $("#js--product-id").val(),
        type: 'GET',
        success: function (response) {
            let categoryTagTemplate = '';
            $('#js--category-tag').addClass(`${response.length < 1 ? 'd-none' : 'd-flex'}`);
            if (!!response && response.length > 0) {
                 response.map(item => {
                    categoryTagTemplate += generateCategoryTagTemplate(item);
                });
            }
            $('#js--category-tag').html(categoryTagTemplate);
        },
        error: function (err) {}
    });
}

getCategories();